import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { memo } from "react";
import { Link } from 'react-router-dom';

const OrderNumberCell = (props: GridCustomCellProps) => {
  const { dataItem } = props;
  if (!dataItem.OrderID) return <td {...props.tdProps} />;
  return <td {...props.tdProps}>
    <Link
      style={{ color: '#007bff' }}
      title={dataItem.OrderStatus}
      to={`/Order/${dataItem.OrderID}`}
    >
      {dataItem.OrderNumber || "View"}
    </Link>
  </td>
}

export default memo(OrderNumberCell, (prev, next) => prev.dataItem.OrderID === next.dataItem.OrderID);
